export default "__VITE_ASSET__VHKL4jre__"